import Result from "@/core/common/Result";

export type SalvarAgendamentoInput = {
  uri: string;
  tipo: number;
};

export interface ICriarAgendamentoUseCase {
  execute(input: SalvarAgendamentoInput): Promise<Result<void>>;
}

export const criarAgendamentoUseCaseDI = "criarAgendamentoUseCaseDI";
